import {ConnectBilling, ConnectBillingContract} from 'app/components/entities/billing/connect';
import {apiClient} from 'app/components/shared';

export class ConnectBillingApi {
  static async getPlan(teamId: string): Promise<ConnectBilling.Plan | null> {
    return apiClient.get<ConnectBilling.Plan | null>(
      `/front/api/v1t/team/${teamId}/billing/v2/econnect/plan`,
    );
  }

  static async subscribe(teamId: string): Promise<void> {
    return apiClient.post(`/front/api/v1t/team/${teamId}/billing/v2/econnect/plan`);
  }

  static async unsubscribe(teamId: string): Promise<void> {
    return apiClient.delete(`/front/api/v1t/team/${teamId}/billing/v2/econnect/plan`);
  }

  static async resumeSubscription(teamId: string): Promise<void> {
    return apiClient.post(`/front/api/v1t/team/${teamId}/billing/v2/econnect/plan/resume`);
  }

  static getHistory(teamId: string): Promise<ConnectBillingContract.History> {
    return apiClient.get(
      `/front/api/v1t/team/${teamId}/teams/${teamId}/billing/v2/econnect/invoice/history`,
    );
  }

  static async getTiers(): Promise<ConnectBillingContract.Tier[]> {
    return apiClient.get<ConnectBillingContract.Tier[]>('/front/api/v1t/billing/v2/econnect/plans');
  }
}
